import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface UncategorizedItemsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function UncategorizedItemsCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: UncategorizedItemsCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Uncategorised Transactions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">12</div>
          <Button size="sm" variant="link" className="p-0 h-auto mt-1">
            Categorise Now
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
